module.exports = __webpack_public_path__ + "static/media/aso-lbc.449f8413.png";